// extracted by mini-css-extract-plugin
export default {"modalContainer":"Vz","fadeRight":"Wz","fadeUp":"Xz","topShelf":"Yz","newFlavorBadge":"Zz","transparentText":"aA","cancelButton":"bA","invisibleLink":"cA","closeIcon":"eA","linkContainer":"fA","hed":"gA","image":"hA"};
    if(module.hot) {
      // 1714654886365
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  